import request from '@/utils/request'

export function ccBuyRecord(data) {
    return request({
      url: '/admin/ccBuyRecord/list',
      method: 'post',
      data
    })
  }

  export function ccSaleList(data) {
    return request({
      url: '/admin/ccSale/list',
      method: 'post',
      data
    })
  }
  export function ccMemberBehaviorList(data) {
    return request({
      url: '/admin/ccMemberBehavior/list',
      method: 'post',
      data
    })
  }
  export function approve(data) {
    return request({
      url: '/admin/ccSale/approve',
      method: 'post',
      data
    })
  }
  export function reject(data) {
    return request({
      url: '/admin/ccSale/reject',
      method: 'post',
      data
    })
  }
  export function ccSaleDelist(data) {
    return request({
      url: '/admin/ccSale/delist',
      method: 'post',
      data
    })
  }
  export function confirmReceipt(data) {
    return request({
      url: '/admin/ccSale/confirmReceipt',
      method: 'post',
      data
    })
  }
  export function ccPaymentMethodList(data) {
    return request({
      url: '/admin/ccPaymentMethod/list',
      method: 'post',
      data
    })
  }
  export function ccPaymentMethodUpdate(data) {
    return request({
      url: '/admin/ccPaymentMethod/update',
      method: 'post',
      data
    })
  }
  export function noReceipt(data) {
    return request({
      url: '/admin/ccSale/noReceipt',
      method: 'post',
      data
    })
  }
  export function countryList(data) {
    return request({
      url: '/admin/ccMemberVerification/countryList',
      method: 'post',
      data
    })
  }
  export function updateCurrency(data) {
    return request({
      url: '/admin/ccMemberVerification/updateCurrency',
      method: 'post',
      data
    })
  }
  export function CcMemberVerificationList(data) {
    return request({
      url: '/admin/ccMemberVerification/list',
      method: 'post',
      data
    })
  }
  export function approveCcMemberVerification(data) {
    return request({
      url: '/admin/ccMemberVerification/approve',
      method: 'post',
      data
    })
  }
  export function rejectCcMemberVerification(data) {
    return request({
      url: '/admin/ccMemberVerification/reject',
      method: 'post',
      data
    })
  }